var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.26 14.83V6.75C20.26 4.67893 18.5811 3 16.51 3H7.75C5.67893 3 4 4.67893 4 6.75V17.29C4 19.0628 5.43717 20.5 7.21 20.5H19.51C19.9242 20.5 20.26 20.1642 20.26 19.75C20.26 19.3358 19.9242 19 19.51 19H7.21C6.26559 19 5.5 18.2344 5.5 17.29C5.5 16.3456 6.26559 15.58 7.21 15.58H19.51C19.9242 15.58 20.26 15.2442 20.26 14.83ZM5.5 14.58V6.75C5.5 5.50736 6.50736 4.5 7.75 4.5H16.51C17.7526 4.5 18.76 5.50736 18.76 6.75V14.08H7.21C6.60416 14.0814 6.01118 14.2548 5.5 14.58Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46 17.29C6.46 16.8758 6.79578 16.54 7.21 16.54H18.28C18.6942 16.54 19.03 16.8758 19.03 17.29C19.03 17.7042 18.6942 18.04 18.28 18.04H7.21C6.79578 18.04 6.46 17.7042 6.46 17.29Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.497ce485106b258610f2b028ccf36397.svg";
export { ForwardRef as ReactComponent };